import React, { useState } from "react";
import { useMapEvents } from "react-leaflet";
import ModalInfo from "./ModalInfo";
import ModalStat from "./ModalStat";
import ModalUsers from "./ModalUsers";
import PautinaDialog from "./PautinaDialog";

const Modal = () => {
    const [modal, setModal] = useState(null)
    useMapEvents({
        modalclose: () => {
            setModal(null)
        },
        openModal: (props) => {
            console.log(props)
            setModal(props)
          
        }
      });

    if (!modal) return null
    if (modal.variant === 'info') return <ModalInfo host={modal.host} hostType={modal.hostType.startsWith('@') ? 'others' : modal.hostType} />
    if (modal.variant === 'statistic') return <ModalStat />
    if (modal.variant === 'users') return <ModalUsers />
    if (modal.variant === 'pautina') return <PautinaDialog />
}




export default Modal